// extracted by css-extract-rspack-plugin
export default {"analyzedByTag":"jLebuuiW2FAgsp5q","primary":"XYegHUTfWwZDs3zj","label":"ZJZNYlhUZwY4J4gV","unit":"hDVPv3mLFHEpMR7p","tertiary":"JvdKUSu8c16tYS7K"};